export default {"src":"/_next/static/media/NoTeamsFound.e5482428.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};